import React from 'react';
import { Icon, Message, Modal, Popup, Table } from 'semantic-ui-react';
import { Resultados } from 'src/api';
import { ResumenDeCurso } from 'src/api/protocolo/horarios';
import { Fecha, NombrePersonal } from 'src/componentes';
import { ModalEnfocable } from 'src/componentes/semantic-ui-extended';
import { Contexto } from 'src/contexto';
import { InformacionDeCurso } from '../../componentes/InformacionDeCurso';

type RecuperacionesDTO = Resultados<'recuperacionesAgendadasDelAlumno'>;

export type Props = Readonly<{
    recuperaciones: RecuperacionesDTO;
    todosLosCursos?: Map<string, ResumenDeCurso>;
    eliminandoRecuperacion: boolean;
    alCerrarModalRecuperacion: () => void;
    alEliminar: (idRecuperacion: string, idAlumno: string) => void;
}>;

class RecuperacionesAgendadas extends React.PureComponent<Props> {
    public static readonly contextType = Contexto;
    public readonly context!: React.ContextType<typeof Contexto>;

    public render() {
        const {
            recuperaciones,
            todosLosCursos: mapaDeTodosLosCursos,
            alEliminar,
            eliminandoRecuperacion,
            alCerrarModalRecuperacion,
        } = this.props;

        const esEncargadoDocente = this.context.usuarioActual.tieneAlgunaDeEstasFunciones(
            'encargado_docente',
        );

        if (recuperaciones.length === 0) {
            return (
                <div>
                    <Message info>
                        <Message.Content>
                            El alumno no posee recuperaciones agendadas.
                        </Message.Content>
                    </Message>
                </div>
            );
        }
        if (mapaDeTodosLosCursos === undefined) {
            return <Icon loading name='spinner' />;
        }

        return (
            <div>
                <Table collapsing>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell content='Nº de clase' />
                            <Table.HeaderCell content='Fecha en que recupera' />
                            <Table.HeaderCell content='Curso de origen' />
                            <Table.HeaderCell content='Curso de destino' />
                            <Table.HeaderCell content='Ingresado por' />
                            <Table.HeaderCell content='Fecha en que se agendó' />
                            {esEncargadoDocente && <Table.HeaderCell />}
                        </Table.Row>
                    </Table.Header>

                    <Table.Body>
                        {recuperaciones.map(recuperacion => {
                            const cursoDeOrigen = mapaDeTodosLosCursos.get(
                                recuperacion.cursoDeOrigen,
                            );
                            const cursoDeDestino = mapaDeTodosLosCursos.get(
                                recuperacion.cursoDeDestino,
                            );

                            if (eliminandoRecuperacion) {
                                return (
                                    <ModalEliminacion
                                        alCerrar={alCerrarModalRecuperacion}
                                        alConfirmar={() =>
                                            alEliminar(recuperacion.id, recuperacion.alumno.id)
                                        }
                                    />
                                );
                            } else {
                                return (
                                    <Table.Row key={recuperacion.id}>
                                        <Table.Cell content={recuperacion.numeroDeClase} />

                                        <Table.Cell
                                            content={<Fecha fecha={recuperacion.fecha} />}
                                        />

                                        <Table.Cell
                                            selectable={!!cursoDeOrigen}
                                            content={
                                                cursoDeOrigen ? (
                                                    <InformacionDeCurso {...cursoDeOrigen} />
                                                ) : (
                                                    recuperacion.cursoDeOrigen
                                                )
                                            }
                                        />

                                        <Table.Cell
                                            selectable={!!cursoDeDestino}
                                            content={
                                                cursoDeDestino ? (
                                                    <InformacionDeCurso {...cursoDeDestino} />
                                                ) : (
                                                    recuperacion.cursoDeDestino
                                                )
                                            }
                                        />

                                        <Table.Cell>
                                            <NombrePersonal
                                                nombre={recuperacion.ingresadoPor.nombre}
                                                patron='%N %P'
                                            />
                                        </Table.Cell>

                                        <Table.Cell
                                            content={<Fecha fecha={recuperacion.ingresadoEl} />}
                                        />

                                        {esEncargadoDocente && (
                                            <Table.Cell>
                                                <Popup
                                                    trigger={
                                                        <Icon
                                                            circular
                                                            link
                                                            name='close'
                                                            onClick={() =>
                                                                alEliminar(
                                                                    recuperacion.id,
                                                                    recuperacion.alumno.id,
                                                                )
                                                            }
                                                        />
                                                    }
                                                    content='Eliminar'
                                                    inverted
                                                />
                                            </Table.Cell>
                                        )}
                                    </Table.Row>
                                );
                            }
                        })}
                    </Table.Body>
                </Table>
            </div>
        );
    }
}

export default RecuperacionesAgendadas;

const ModalEliminacion = (props: { alConfirmar(): void; alCerrar(): void }) => (
    <ModalEnfocable open closeIcon onClose={props.alCerrar}>
        <Modal.Header content='¿Está seguro que quiere eliminar esta recuperación?' />
        <Modal.Content content='Esta acción no se puede deshacer' />
        <Modal.Actions
            actions={[
                { key: 'no', content: 'No', onClick: props.alCerrar },
                {
                    key: 'si',
                    content: 'Sí',
                    negative: true,
                    onClick: () => {
                        props.alConfirmar();
                        props.alCerrar();
                    },
                },
            ]}
        />
    </ModalEnfocable>
);



// WEBPACK FOOTER //
// ./src/modulos/Alumnos/paginas/FichaDeAlumno/paginas/RecuperacionesDeAlumno/index.tsx